import React from 'react';
import { Link } from 'react-router';
import SearchInput from 'react-search-input';

/* eslint-disable */
const PanelList = props => (
  <div className={props.color ? `panel-list ${props.color}` : "panel-list" }>
    <div className="navigationbar">
      { props.actionLeft ?
        <div className="navigationbar-action">
          <div className="action-left">
            <Link onClick={props.actionLeft}><i className={ props.actionLeftIcon ? `icon ${props.actionLeftIcon}` : 'icon icon-add'}></i></Link>
          </div>
        </div>
        :
        ''
      }
      <h2>{props.title ? props.title : location.pathname }</h2>
      { props.actionRight ?
        <div className="navigationbar-action">
          <div className="action-right">
            <Link onClick={props.actionRight}><i className={ props.actionRightIcon ? `icon ${props.actionRightIcon}` : 'icon icon-add'}></i></Link>
          </div>
        </div>
        :
        ''
      }
    </div>
    { props.handleSearch ?
      <div className="panel-list-search-container">
        <SearchInput
          id="q"
          className="search input-text placeholder-processed"
          type="text"
          placeholder="Search..."
          onChange={ (e) => props.handleSearch(e) } />
      </div>
      :
      ''
    }
    <ul>
      { props.children }
    </ul>
  </div>
);

export default PanelList;



// WEBPACK FOOTER //
// ./src/components/layout/panel-list/index.jsx